import { CustomDatePipe } from 'app/shared/pipes/custom-date.pipe';

/**
 * Builds a notification-card title of the form "<label> - <date> <HH:mm>".
 *
 * The date and time are always read from the raw view-model instant (an ISO string),
 * never from the card's own `notificationDate`: the latter is snapped to midnight
 * (used for the read/unread comparison), so feeding it here would display "00:00".
 */
export function buildNotificationCardTitle(label: string, notificationDate: string, customDatePipe: CustomDatePipe): string {
  return `${label} - ${customDatePipe.transform(notificationDate)} ${customDatePipe.transform(notificationDate, 'HH:mm')}`;
}
